import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getCompanyList, getCostCenterList, getManagementList, getManagementPositionList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import { addNewPerson, updatePerson } from '../../../../slices/thunks';
import validateRUT from '../../../../helpers/utils/validateRUT';
import { setRequireCloseModal } from '../../../../slices/person/reducer';
import OInput from '../../../../Components/OElements/OInput';

const PersonForm = ({ dataPerson, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const selectorPerson = createSelector(
		state => state.Persons,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorPerson);

	const [selectedManagement, setSelectedManagement] = useState(null);
	const handleSelectedManagement = (optionSelected) => {
		setSelectedManagement(optionSelected);
	};


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			first_name: (dataPerson && dataPerson.first_name) || '',
			second_name: (dataPerson && dataPerson.second_name) || '',
			first_surname: (dataPerson && dataPerson.first_surname) || '',
			second_surname: (dataPerson && dataPerson.second_surname) || '',
			rut: (dataPerson && dataPerson.rut) || '',
			mail: (dataPerson && dataPerson.mail) || '',
			phone: (dataPerson && dataPerson.phone) || null,
			company_id: (dataPerson && dataPerson.company_id) || '',
			cost_center_id: (dataPerson && dataPerson.cost_center_id) || null,
			management_position_id: (dataPerson && dataPerson.management_position_id) || '',
			management_id: (dataPerson && dataPerson.management_id) || '',
			active: (dataPerson && dataPerson.active ? 'Activo' : 'Inactivo') || 'Activo',
		},
		validationSchema: Yup.object({
			first_name: Yup.string().required('Campo requerido'),
			second_name: Yup.string().nullable(),
			first_surname: Yup.string().required('Campo requerido'),
			second_surname: Yup.string().required('Campo requerido'),
			rut: Yup.string().required('Campo requerido').test('valid-rut', 'RUT inválido', value => validateRUT(value)),
			mail: Yup.string().nullable(),
			phone: Yup.string().nullable(),
			company_id: Yup.string().required('Campo requerido'),
			cost_center_id:  Yup.string().required('Campo requerido'),
			management_position_id: Yup.string().required('Campo requerido'),
			management_id: Yup.string().required('Campo requerido'),
			active: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			const person = { ...values };
			person.name = values.first_name + ' ' + values.first_surname
			person.active = values.active == 'Activo';
			if (isEdit) {
				person._id = dataPerson._id;
				dispatch(updatePerson(person));
			} else {
				dispatch(addNewPerson(person));
			}
			dispatch(setRequireCloseModal(false));
		},
	});
	// console.log('validation', validation.values);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={3}>
						<OInput
							name='first_name'
							label='Primer Nombre'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='second_name'
							label='Segundo Nombre'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='first_surname'
							label='Primer Apellido'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='second_surname'
							label='Segundo Apellido'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='rut'
							label='RUT'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>

					<Col lg={3}>
						<OInput
							name='mail'
							label='Correo'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='phone'
							label='Celular'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Cargo'
							id='management_position_id'
							name='management_position_id'
							isRequired={true}
							value={validation.values.management_position_id || ''}
							onChange={validation.handleChange}
							requestApi={() => getManagementPositionList()}
							validation={validation}
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Empresa'
							id='company_id'
							name='company_id'
							isRequired={true}
							value={validation.values.company_id || ''}
							onChange={validation.handleChange}
							requestApi={() => getCompanyList()}
							validation={validation}
						/>
					</Col>
					<Col lg={4}>
						<OSelect
							key={'cost_center_id' + validation.values.company_id}
							handleLabelOptions={(item) => `${ item.code + ': ' + item.name.toUpperCase()}`}							
							label='Centro de Costo'
							id='cost_center_id'
							name='cost_center_id'
							isRequired={true}
							value={validation.values.cost_center_id || null}
							disabled={!validation.values.company_id}
							onChange={validation.handleChange}
							requestApi={() => getCostCenterList({ company_id: validation.values.company_id })}
							validation={validation}
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Departamento'
							id='management_id'
							name='management_id'
							isRequired={true}
							value={validation.values.management_id || ''}
							onChange={validation.handleChange}
							onSelect={handleSelectedManagement}
							requestApi={() => getManagementList()}
							validation={validation}
						/>
					</Col>
					<Col lg={2}>
						<OSelect
							label='Activo'
							id='active'
							name='active'
							isRequired={true}
							value={validation.values?.active || false}
							onChange={validation.handleChange}
							itemsSelect={[{ label: 'Activo', value: 'Activo' }, { label: 'Inactivo', value: 'Inactivo' }]}
							validation={validation} />
					</Col>

				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isAdding || isUpdating}>
						{isAdding || isUpdating ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Crear'} Persona
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PersonForm;
